import { useEffect, useState } from 'react';
import { flareAPI } from '../services/api';

/**
 * useEntryConfig — KAN-488 option 1 (Ray, 14231): whether a visitor signs up FIRST (age, consent,
 * guardian consent for 13-17) and then goes straight into Challenge 1.
 *
 * One server-side switch (ENTRY_SIGNUP_FIRST), read from a public endpoint, so turning it on
 * needs no frontend rebuild. Fetched once per page load and shared.
 *
 * FAILS TO TODAY'S BEHAVIOUR. A failed read is `signupFirst: false`: the visitor gets the puzzle
 * first, as now, rather than a sign-up wall nobody switched on.
 */
let cached = null;      // resolved boolean, once known
let inflight = null;    // the one request in flight

export function _resetEntryConfigForTests() {
  cached = null;
  inflight = null;
}

function load() {
  if (cached !== null) return Promise.resolve(cached);
  if (!inflight) {
    inflight = flareAPI.entryConfig()
      .then((res) => Boolean(res && res.data && res.data.signup_first))
      .catch(() => false)
      .then((v) => { cached = v; inflight = null; return v; });
  }
  return inflight;
}

export default function useEntryConfig() {
  const [state, setState] = useState(
    cached !== null ? { loading: false, signupFirst: cached } : { loading: true, signupFirst: false },
  );
  useEffect(() => {
    let alive = true;
    if (cached === null) {
      load().then((v) => { if (alive) setState({ loading: false, signupFirst: v }); });
    }
    return () => { alive = false; };
  }, []);
  return state;
}
